export default {
  manifest: {
    title: 'Conheça Nossas Iniciativas de ESG que Guiam Nossas Ações',
    desc: 'Nosso compromisso com práticas responsáveis e transparentes.',
    button: 'Acesse Nosso Manifesto',
  },
}
